module.exports = __webpack_public_path__ + "assets/img/to-be-received.a4df994f.png";